"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ProductRatingQuery = (0, graphql_tag_1.default) `
  query ProductRating(
    $variationId: String
    $filters: [Filter]
    $includeUserReviews: Boolean = false
    $page: Int = 1
    $pageSize: Int = 8
    $sortType: UserReviewsSortType = MORE_RELEVANT
    $hasTag: Boolean = true
  ) {
    productRating(variationId: $variationId, hasTag: $hasTag) {
      productId
      userReviews(
        userReviewRequest: {
          filters: $filters
          pagination: { page: $page, size: $pageSize }
          sortType: $sortType
        }
        hasTag: $hasTag
      ) @include(if: $includeUserReviews) {
        items {
          product {
            images
            productLink
            productName
            ratingValue
            sku
            videos
          }
          reviewId
          description
          rating
          title
          submissionDate
          userData {
            name
          }
          attributes {
            label
            value
          }
          dimensions {
            id
            label
          }
        }
        page {
          current
          totalItems
          totalPages
        }
      }
      dimensions {
        id
        label
        rating
      }
    }
  }
`;
exports.default = ProductRatingQuery;
